import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import BookmarkBorder from '@mui/icons-material/BookmarkBorder';
import ProductRow from 'features/common/components/ProductRow';
import { Card } from '@totalsoft/rocket-ui';
import {
  ProductTitleWrapper,
  ServicesWrapper,
  ServicesAreaWrapper,
  ServicesTextWrapper,
  ServicesPlaceholderWrapper,
  ProductButtonWrapper,
  FinancialProductCardWrapper
} from 'features/simulator/SimulatorStyles';

const SimulatorFinancialProductComponent = ({
  t,
  product,
  partnerAgreesWithPersonalDataUse,
  savingOffer,
  completed,
  selectedProductId,
  canGenerateContract,
  onGenerateOffer,
  onGenerateContract
}) => {
  const disabledOffer = useMemo(
    () => product.productId <= 0 || (selectedProductId && selectedProductId !== product.productId) || completed.offer || savingOffer,
    [selectedProductId, product.productId, completed.offer, savingOffer]
  );
  const disabledKyc = useMemo(
    () =>
      product.productId <= 0 ||
      (selectedProductId && selectedProductId !== product.productId) ||
      !partnerAgreesWithPersonalDataUse ||
      completed.kyc ||
      savingOffer,
    [selectedProductId, product.productId, partnerAgreesWithPersonalDataUse, completed.kyc, savingOffer]
  );

  return (
    <FinancialProductCardWrapper item xs={12} md={6} lg={4}>
      <Card icon={BookmarkBorder} selectedProductId={selectedProductId !== product.productId}>
        <Grid item xs={12}>
          <ProductTitleWrapper> {product.name} </ProductTitleWrapper>
        </Grid>
        <React.Fragment>
          <ProductTitleWrapper>{product.contractTypeName}</ProductTitleWrapper>
          <Grid container alignItems='center'>
            <ProductRow
              left={`${t('OfferEdit.FinancialProducts.Rate')}:`}
              right={`${
                product.monthlyRateValueWithoutVat === null ? '-' : t('DECIMAL2', { number: product.monthlyRateValueWithoutVat })
              } ${product.currencyCode === null ? '-' : product.currencyCode}`}
            />
            <ProductRow
              left={`${t('OfferEdit.FinancialProducts.RateWithVAT')}:`}
              right={`${product.monthlyRateValue === null ? '-' : t('DECIMAL2', { number: product.monthlyRateValue })} ${
                product.currencyCode === null ? '-' : product.currencyCode
              }`}
            />
            <ProductRow
              left={`${t('OfferEdit.FinancialProducts.Period')} (${t('OfferEdit.FinancialProducts.months')}):`}
              right={product.periodMonths === null ? '-' : product.periodMonths}
            />
            <ProductRow
              left={`${t('OfferEdit.FinancialProducts.AdvancePercent')}:`}
              right={product.advancePercent === null ? '-' : `${t('PERCENT_NUMBER', { number: product.advancePercent })}%`}
            />
            {/* <ProductRow
                left={`${t("OfferEdit.FinancialProducts.NumberOfGuaranteeRates")}:`}
                right={product.numberOfGuaranteeRates === null ? "-" : product.numberOfGuaranteeRates}
              /> -- pentru moment nu se stie ce valoare se pune aici -- */}
            <ProductRow
              left={`${t('OfferEdit.FinancialProducts.ResidualValuePercent')}:`}
              right={product.rezidualValue === null || product.hideVR ? '-' : `${t('PERCENT_NUMBER', { number: product.rezidualValue })}%`}
            />
            {/* <ProductRow
                left={`${t("OfferEdit.FinancialProducts.ContractAmount")}:`}
                right={`${product.contractValue === null ? "-" : t("DECIMAL2", { number: product.contractValue })} ${
                  product.currencyCode === null ? "-" : product.currencyCode
                }`}
              /> -- pentru moment nu se stie ce valoare se pune aici -- */}

            <ServicesWrapper>
              <Grid item xs={12}>
                <ProductTitleWrapper>{`${t('OfferEdit.FinancialProducts.IncludedServices')}`}</ProductTitleWrapper>
              </Grid>
              {Array.isArray(product.services) && product.services.length > 0 ? (
                <ServicesAreaWrapper item xs={12}>
                  <ServicesTextWrapper>{product.services.map(x => x.serviceName).join(', ')}</ServicesTextWrapper>
                </ServicesAreaWrapper>
              ) : (
                <ServicesPlaceholderWrapper>{'-'}</ServicesPlaceholderWrapper>
              )}
            </ServicesWrapper>

            <Grid item xs={12} align='center'>
              <ProductButtonWrapper color='primary' onClick={() => onGenerateOffer(product)} disabled={disabledOffer}>
                {t('Simulator.Product.WantOffer')}
              </ProductButtonWrapper>
              {canGenerateContract && (
                <ProductButtonWrapper color='primary' disabled={disabledKyc} onClick={() => onGenerateContract(product)}>
                  {t('Simulator.Product.WantContract')}
                </ProductButtonWrapper>
              )}
            </Grid>
          </Grid>
        </React.Fragment>
      </Card>
    </FinancialProductCardWrapper>
  );
};

SimulatorFinancialProductComponent.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  partnerAgreesWithPersonalDataUse: PropTypes.bool.isRequired,
  savingOffer: PropTypes.bool.isRequired,
  completed: PropTypes.object.isRequired,
  selectedProductId: PropTypes.number,
  canGenerateContract: PropTypes.bool.isRequired,
  onGenerateOffer: PropTypes.func.isRequired,
  onGenerateContract: PropTypes.func.isRequired
};

export default withTranslation()(SimulatorFinancialProductComponent);
